import { Box, Flex, VStack } from '@chakra-ui/react';
import { ErrorMessage, Field, Formik } from 'formik';
import axios from 'axios';
import { InputControl, TextareaControl } from 'formik-chakra-ui';
import * as React from 'react';
import * as Yup from 'yup';
import CustomButton from '../customButton/customButton';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const onSubmit = (values, { setSubmitting, setStatus, resetForm }) => {
  sleep(300).then(() => {
    setStatus();
    const formData = new FormData();
    let formId = '';
    let lang = '';
    let tutorialFile = '';
    let type = '';
    for (const [key, value] of Object.entries(values)) {
      formData.append(key, value);
      if (key === 'formId') formId = value;
      if (key === 'lang') lang = value;
      if (key === 'tutorialFile') tutorialFile = value;
      if (key === 'type') type = value;
    }

    const thanks = lang === 'en' ? 'Thank you for your message' : 'Dziękujemy za przesłaną wiadomość.';
    const thanksTutorial =
      lang === 'en' ? 'Thank you. You can download the guide book' : 'Dziękujemy. Możesz pobrać poradnik';

    formData.append('template', 'contact');
    formData.append('url', window.location.href);
    formData.append('subject', 'Zapytanie ze strony cyrekdigital.com');
    formData.append('mailerFrom', 'powiadomienia@cyrekdigital.com');
    formData.append('mailerTo', 'powiadomienia@cyrekdigital.com');
    formData.append('mailerFromName', 'Strona CyrekDigital');

    axios({
      method: 'POST',
      url: process.env.GATSBY_API_URL + '?module=mailer',
      data: formData,
      header: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(res => {
        resetForm();
        setSubmitting(false);
        document.getElementById(formId).style.display = 'none';
        window.dataLayer.push({ event: 'Form sent' });
        setStatus(
          <Box background={'#008F47'} p={'10px'} color={'#FFF'} mt={'40px'}>
            {type === 'tutorial' ? thanksTutorial : thanks}
          </Box>,
        );
        {
          tutorialFile && window.open(tutorialFile, '_blank');
        }
      })
      .catch(err => {
        alert('error!');
      });
  });
};

const ContactForm = props => {
  const lang = props.lang?.toLowerCase() ?? 'pl';
  const isTutorialForm = props.type && props.type === 'tutorial' ? true : false;
  const isCaseForm = props.type && props.type === 'case' ? true : false;
  const isImplementation = props.type && props.type === 'implementation' ? true : false;
  const caseheader = props?.caseheader && props?.caseheader;
  const casesubheader = props?.casesubheader && props.casesubheader;

  //console.log(isImplementation);

  // console.log(caseheader);
  // console.log(casesubheader);
  // console.log(props);

  const translations = {
    name_surname: {
      pl: 'Imię i nazwisko',
      en: 'Name and surname',
    },
    your_email: {
      pl: 'Twój adres e-mail',
      en: 'Your e-mail address',
    },
    phone_number: {
      pl: 'Nr telefonu',
      en: 'Phone number',
    },
    domain_name: {
      pl: 'Nazwa domeny',
      en: 'Domain name',
    },
    message: {
      pl: 'Napisz wiadomość',
      en: 'Message',
    },
    privacy: {
      pl: 'Zapoznałem/am się z <a href="/pl/polityka-prywatnosci/" rel="noreferrer" target="_blank">Polityką Prywatności</a> oraz klauzulą informacyjną <a href="/pl/rodo/" rel="noreferrer" target="_blank">RODO</a>',
      en: 'I have read the  <a href="/en/privacy-policy/" rel="noreferrer" target="_blank">Privacy Policy</a> and the information clause <a href="/en/gdpr/" rel="noreferrer" target="_blank">GDPR</a>',
    },
    send_form: {
      pl: isTutorialForm ? 'Pobierz poradnik' : 'Wyślij zapytanie',
      en: isTutorialForm ? 'Download guide book' : 'Send form',
    },
    mandatory_fields: {
      pl: 'Pola wymagane',
      en: 'Mandatory fields',
    },
    mandatory_name: {
      pl: 'Podanie danych jest wymagane',
      en: 'Name is mandatory',
    },
    mandatory_email: {
      pl: 'Mail jest wymagany',
      en: 'E-mail is mandatory',
    },
    mandatory_phone: {
      pl: 'Numer telefonu jest wymagany',
      en: 'Phone number is mandatory',
    },
    mandatory_domain: {
      pl: 'Adres domeny jest wymagany',
      en: 'Domain name is mandatory',
    },
    mandatory_privacy: {
      pl: 'Zgoda jest wymagana',
      en: 'Accepting privacy form is mandatory',
    },
    email_incorrect: {
      pl: 'Błędny format e-mail',
      en: 'E-mail is not valid',
    },
  };

  const placement = props.placement ? props.placement : 'footer';
  const ommitFullname = !(props.ommit && props.ommit === 'fullName');

  const validationSchema = Yup.object({
    ...(placement !== 'footer' &&
      ommitFullname && { fullName: Yup.string().required(translations['mandatory_name'][lang]) }),
    email: Yup.string().email(translations['email_incorrect'][lang]).required(translations['mandatory_email'][lang]),
    phone: Yup.number().required(translations['mandatory_phone'][lang]),
    ...(placement !== 'hero' &&
      placement !== 'contact' && { domain: Yup.string().required(translations['mandatory_domain'][lang]) }),
    agreement: Yup.boolean().oneOf([true], translations['mandatory_privacy'][lang]),
  });

  const message = props.message ?? '';
  const formMarketingFields =
    props.formmarketingfields && (props.formmarketingfields.showmarketingform || isTutorialForm)
      ? props.formmarketingfields
      : null;
  const tutorialFile = formMarketingFields?.tutorialFile?.localFile?.url ?? null;

  const basicFormMarketingFields = {
    header: {
      pl: isTutorialForm
        ? 'Wypełnij formularz i pobierz darmowy poradnik'
        : isCaseForm
        ? caseheader
        : isImplementation
        ? caseheader
        : 'Rozwijaj swoją markę',
      en: isTutorialForm ? 'Fill out the form and download the free guide' : 'Develop your brand',
    },
    subHeader: {
      pl: isTutorialForm
        ? ''
        : isCaseForm
        ? casesubheader
        : isImplementation
        ? casesubheader
        : 'dzięki współpracy z Cyrek Digital',
      en: isTutorialForm ? '' : 'thanks to cooperation with Cyrek Digital',
    },
  };

  const placementStyles = [
    {
      footer: { size: { base: '15px', lg: '18px', xxl: '26px' } },
      contact: { size: { base: '15px', lg: '16px', xxl: '22px' } },
      content: { size: { base: '15px', lg: '16px', xxl: '22px' } },
      hero: { size: '18px' },
    },
  ];

  const ids = [
    {
      footer: 'footer-form',
      contact: 'contact-form',
      content: 'content-form',
      hero: 'hero-form',
    },
  ];

  const initialValues = {
    fullName: '',
    email: '',
    phone: '',
    domain: '',
    message: '',
    formId: ids[0][placement],
    agreement: false,
    lang: lang,
    tutorialFile: tutorialFile ? tutorialFile : null,
    type: isTutorialForm ? 'tutorial' : 'default',
  };

  return (
    <Box background={'#fff'} {...props}>
      <Box
        as={'h2'}
        fontWeight={'bold'}
        fontSize={placementStyles[0][placement]['size']}
        mb={{ base: '16px', lg: '5px', xxl: '20px' }}
        lineHeight={{ base: '24px', lg: '26px', xxl: '32px' }}
        ml={{ base: '-10px', lg: '0' }}
      >
        {formMarketingFields && formMarketingFields.formheader
          ? formMarketingFields.formheader
          : basicFormMarketingFields.header[lang]}
      </Box>
      <Box fontSize={{ base: '13px' }} ml={{ base: '-10px', lg: '0' }}>
        {formMarketingFields && formMarketingFields.formsubtitle
          ? formMarketingFields.formsubtitle
          : basicFormMarketingFields.subHeader[lang]}
      </Box>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
        {({ handleSubmit, values, setFieldValue, errors, status }) => (
          <Box borderWidth="0" m="10px auto" as="form" onSubmit={handleSubmit}>
            {status}
            <VStack
              spacing={{ base: '20px', xxl: '40px' }}
              align="flex-start"
              p={'20px 0 0 0'}
              m="10px 0 0 0"
              maxW={{ base: '100%', xxl: '455px' }}
              id={ids[0][placement]}
              className={'contactForm'}
              transition="all 0.3s"
              sx={{
                '*': { fontSize: { base: '12px', xxl: '15px' } },
                '.chakra-form__required-indicator': { display: 'none' },
                '.chakra-form__error-message': { fontSize: '11px', mt: '0px', float: 'right', mb: '-20px' },
                '.abs label': {
                  position: 'absolute',
                  top: '8px',
                  pl: '10px',
                  color: 'gray.dark',
                  fontSize: { base: '12px', xxl: '15px' },
                  fontWeight: 'inherit',
                },
                '.abs::before': {
                  content: "'■'",
                  color: 'brand.lightBlue',
                  fontWeight: 'bold',
                  mr: '10px',
                  ml: '-10px',
                  display: 'inline',
                  position: 'absolute',
                  top: '3px',
                  fontSize: '7px',
                  left: '5px',
                },
                'label.isFilled, .abs label[data-focus]': { top: '40px', fontSize: '12px', color: '#000' },
                'input[aria-invalid="true"],textarea[aria-invalid="true"]': {
                  border: '0',
                  borderRadius: '0',
                  borderBottom: '2px solid',
                  borderColor: 'ui.red',
                  boxShadow: 'none',
                },
                '.abs label[data-invalid] input, #message[data-invalid]': {
                  border: '0',
                  borderBottom: '2px solid',
                  borderColor: 'ui.red',
                  boxShadow: 'none',
                },
                'input:active, input:hover, input:focus, input:focus-visible': {
                  border: '0',
                  borderRadius: '0',
                  borderBottom: '2px solid',
                  borderColor: 'brand.lightBlue',
                  boxShadow: 'none',
                },
                'textarea, input, input[type=checkbox]': { border: '0', borderRadius: '0' },
                'input[type=checkbox]': { mt: '3px', mr: '5px' },
                'input,textarea': {
                  borderBottom: '1px solid',
                  borderColor: 'gray.regular',
                  fontSize: { base: '12px', xxl: '15px' },
                  fontWeight: 'medium',
                },
                '.textarea label': {
                  marginTop: '0',
                  color: 'gray.dark',
                  paddingLeft: '10px',
                  fontSize: { base: '12px', xxl: '15px' },
                  fontWeight: 'inherit',
                },
                a: { fontWeight: 'bold' },
              }}
            >
              {ommitFullname && (
                <InputControl
                  name="fullName"
                  label={translations['name_surname'][lang]}
                  className={'abs'}
                  id={'fullNameGroup'}
                  transition="all 0.3s"
                  onBlur={event => {
                    if (event.target.defaultValue.trim().length > 0) {
                      document.getElementById('fullNameGroup-label').classList.add('isFilled');
                    } else {
                      document.getElementById('fullNameGroup-label').classList.remove('isFilled');
                    }
                  }}
                />
              )}
              <InputControl
                name="email"
                label={translations['your_email'][lang]}
                className={'abs'}
                id={'emailGroup'}
                transition="all 0.3s"
                onBlur={event => {
                  if (event.target.defaultValue.trim().length > 0) {
                    document.getElementById('emailGroup-label').classList.add('isFilled');
                  } else {
                    document.getElementById('emailGroup-label').classList.remove('isFilled');
                  }
                }}
              />
              <InputControl
                name="phone"
                label={translations['phone_number'][lang]}
                className={'abs phone'}
                id={'phoneGroup'}
                transition="all 0.3s"
                onBlur={event => {
                  if (event.target.defaultValue.trim().length > 0) {
                    document.getElementById('phoneGroup-label').classList.add('isFilled');
                  } else {
                    document.getElementById('phoneGroup-label').classList.remove('isFilled');
                  }
                }}
              />
              {placement !== 'hero' && placement !== 'contact' && (
                <InputControl
                  name="domain"
                  label={translations['domain_name'][lang]}
                  className={'abs'}
                  id={'domainGroup'}
                  transition="all 0.3s"
                  onBlur={event => {
                    if (event.target.defaultValue.trim().length > 0) {
                      document.getElementById('domainGroup-label').classList.add('isFilled');
                    } else {
                      document.getElementById('domainGroup-label').classList.remove('isFilled');
                    }
                  }}
                />
              )}
              {message && (
                <TextareaControl
                  name="message"
                  className={'textarea'}
                  label={translations['message'][lang]}
                  sx={{ label: { pl: '0px', mt: '30px' } }}
                />
              )}
              <Flex alignItems={'flex-end'}>
                <Box className="chakra-form-control" role="group">
                  <Box display={'flex'} alignItems={'flex-start'} position={'relative'} pl={'9px'}>
                    <Box
                      as={'span'}
                      color={'brand.lightBlue'}
                      fontWeight={'bold'}
                      ml={'5px'}
                      mr={'5px'}
                      fontSize={'6px'}
                      position={'absolute'}
                      left={'-9px'}
                      top={'0'}
                    >
                      ■
                    </Box>
                    <Box
                      as={'label'}
                      display={'flex'}
                      alignItems={'flex-start'}
                      style={{ fontSize: '11px', ml: '5px' }}
                      sx={{ a: { fontWeight: '400', fontSize: '11px', textDecoration: 'underline' } }}
                    >
                      <Field
                        type="checkbox"
                        color={'green'}
                        name="agreement"
                        className="form-check-input"
                        id="agreement"
                      />
                      <Box
                        as={'p'}
                        fontSize="11px"
                        dangerouslySetInnerHTML={{ __html: translations['privacy'][lang] }}
                      />
                    </Box>
                  </Box>
                  <ErrorMessage
                    style={{ fontSize: '11px', color: '#FF1C1D' }}
                    id="agreementGroup-feedback"
                    name="agreement"
                    component="div"
                    className="chakra-form__error-message"
                  />
                </Box>
              </Flex>
              <Box
                m={{ base: placement === 'content' || placement === 'hero' || placement === 'footer' ? '0' : '  0px' }}
                w={'100%'}
              >
                <CustomButton
                  fontSize={{ base: '15px', lg: '12px', xxl: '15px' }}
                  cursor={'pointer'}
                  text={translations['send_form'][lang]}
                  onClick={handleSubmit}
                  m={'0'}
                  mx={{ base: '-10px', lg: '0' }}
                  width={{ base: 'calc(100% + 20px)', lg: '100%' }}
                  textAlign={'left'}
                  justifyContent={'flex-start'}
                  padding={{ lg: '10px 40px 10px 20px', xxl: '15px 56px 15px 30px' }}
                />
              </Box>
              <Flex
                fontSize={'13px'}
                fontWeight={'medium'}
                justifyContent={'flex-start'}
                position={'relative'}
                pl={'9px'}
              >
                <Box
                  color={'brand.lightBlue'}
                  fontWeight={'bold'}
                  ml={'5px'}
                  mr={'5px'}
                  fontSize={'7px'}
                  position={'absolute'}
                  left={'-9px'}
                >
                  ■
                </Box>
                {translations['mandatory_fields'][lang]}
              </Flex>
            </VStack>
          </Box>
        )}
      </Formik>
    </Box>
  );
};

export default ContactForm;
